import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Flex, FlexItem} from 'react-weui';
import {renderMoney} from '../../utils';

import '../../styles/transactionrecord/TransactionRecordShowMoney.css';

class TransactionRecordShowMoney extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.isLoadMore) {
            return false
        } else {
            return true
        }
    }

    render() {
        const {sy, zc} = this.props;
        return (
            <div className="transaction-record-show-money">
                <Flex>
                    <FlexItem>
                        收入：{renderMoney(sy)}
                    </FlexItem>
                    <FlexItem>
                        提现：{renderMoney(zc)}
                    </FlexItem>
                    <FlexItem>
                        总计：{renderMoney(sy - zc)}
                    </FlexItem>
                </Flex>

            </div>
        );
    }
}

export default connect((state) => ({
    sy: state.transactionRecord.total_fee_gt,
    zc: state.transactionRecord.total_fee_lt,
    isLoadMore: state.transactionRecord.isLoadMore,
}))(TransactionRecordShowMoney)





// WEBPACK FOOTER //
// ./src/components/transactionrecord/TransactionRecordShowMoney.js